import { ReactNode } from "react";
import { Header } from "../Header";
import { Footer } from "components/common/Footer";
import { Container, Row } from "reactstrap";

type PageContainerProps = {
  children: ReactNode;
};

export const PageContainer = (props: PageContainerProps) => {
  return (
    <>
      <div className="app">
        <div className="d-flex flex-grow-1">
          <Header />

          <Container id="main-container" className="main-container">
            <Row>{props.children}</Row>
          </Container>
        </div>
        <Footer />
      </div>
    </>
  );
};
